export default "__VITE_ASSET__CUhmu6c9__"